module.exports = __webpack_public_path__ + "img/visibility-on.72217f4a.svg";